// Helpers for free-text "one item per line" fields (catering, drinks…).
//
// These fields are stored as a string[] (one item per line) but EDITED in a
// <textarea>. The textarea's value is the array joined by "\n"; on change we
// split back. CRITICAL: do NOT filter empty lines on the way in — the user's
// trailing newline (typed when they press Enter to start a new line) is a real
// "\n" that must survive the round-trip, otherwise Enter appears to do nothing.
//
//   value={linesToText(items)}          // render
//   onChange={e => onChange(textToLines(e.target.value))}   // edit

/** Textarea value → array of lines (empty lines preserved for live editing). */
export function textToLines(text: string): string[] {
  return text.split('\n');
}

/** Array of lines → textarea value. */
export function linesToText(lines: string[]): string {
  return (lines || []).join('\n');
}

/** Array of lines → trimmed non-empty lines (for persistence / PDF output). */
export function cleanLines(lines: string[]): string[] {
  return (lines || []).map((l) => l.trim()).filter(Boolean);
}
